import { Dialog, DialogContent } from "@b2bportal/core-ui";
import { useI18nContext } from "@hopper-b2b/i18n";
import terms from "./terms.en.html?raw";
import styles from "./TermsOfServiceModal.module.scss";

interface TermsOfServiceModalProps {
  open: boolean;
  onClose: () => void;
}

export const TermsOfServiceModal = ({
  open,
  onClose,
}: TermsOfServiceModalProps) => {
  const { t } = useI18nContext();

  return (
    <Dialog open={open} onOpenChange={onClose} modal={true}>
      <DialogContent
        showCloseButton={true}
        title={t("footer.termsOfUse")}
        className={styles.termsOfServiceContent}
      >
        <div
          className={styles.termsOfServiceText}
          dangerouslySetInnerHTML={{ __html: terms }}
        />
      </DialogContent>
    </Dialog>
  );
};
